export default "__VITE_ASSET__CM0kS_ta__"